import { Http, Headers , RequestOptions } from '@angular/http';
import { Injectable } from '@angular/core';

import { AuthServiceProvider } from '../auth-service/auth-service';

import 'rxjs/add/operator/map';
import 'rxjs/add/operator/catch';
import 'rxjs/add/operator/toPromise';
/*
  Generated class for the MovimientotesoreriaServiceProvider provider.

  See https://angular.io/guide/dependency-injection for more info on providers
  and Angular DI.
*/
@Injectable()
export class MovimientotesoreriaServiceProvider {

  serverServicios = "";
  headers = new Headers();
  headersPost:any;
  constructor(public http: Http, public autorizacionService: AuthServiceProvider) {
    //this.serverServicios = "http://localhost:3000";
    this.serverServicios = "http://165.227.106.28:3000";

    this.headers.append('Authorization', this.autorizacionService.token);

    this.headersPost = new Headers({ 'Content-Type': 'application/json' });
    this.headersPost.append('Authorization', this.autorizacionService.token);
  }

  getCuentas() {
    return this.http.get(this.serverServicios + '/postesoreria/cuenta/1', {headers: this.headers})
      .map(res => res.json());
  }
  getCuentasExternas(){
    return this.http.get(this.serverServicios + '/postesoreria/externa/1', {headers: this.headers})
      .map(res => res.json());
  }
  getCuentasInternas(){
    return this.http.get(this.serverServicios + '/postesoreria/interna/1', {headers: this.headers})
      .map(res => res.json());
  }

  getMovimientos(idcuentax){
    return this.http.get(this.serverServicios + '/postesoreria/movimientos/1/'+idcuentax, {headers: this.headers})
      .map(res => res.json());
  }

  buscar(idtdoctes, idcuenta, id){
  	return this.http.get(this.serverServicios + '/postesoreria/1/' + idtdoctes + '/' + idcuenta + '/'+ id, {headers: this.headers})
      .map(res => res.json());
  }

  guardarMovimiento(data)
  {
    return new Promise((resolve, reject) => {
      this.http.post(this.serverServicios + '/postesoreria/movimiento', JSON.stringify(data), {headers: this.headersPost}).toPromise().then((response) => {
        resolve(response.json());
      }).catch((error) =>{
        reject(error);
      });
    });
  }
  guardar(data)
  {

    return new Promise((resolve, reject) => {
    this.http.post(this.serverServicios + '/postesoreria/transferencia', JSON.stringify(data), {headers: this.headersPost}).toPromise().then((response) => {
        resolve(response.json());
      }).catch((error) =>{
        reject(error);
      });
    });
  }

  getReporteEstadoCuenta(idempresa,desde,hasta,idcuenta)
  {
    return new Promise(resolve => {
      this.http.get(this.serverServicios + '/pospdf/estadocuenta/'+idempresa+'/'+desde+'/'+hasta+'/'+idcuenta, {headers: this.headers}).map(res => res.json()).subscribe(data => {
        resolve(data);
      }, err => {
        console.log(err);
      });
    });
  }

  documentExists(iddoctes){
    var http = new XMLHttpRequest();
    http.open('HEAD', this.serverServicios + "/documento_"+ iddoctes+".pdf", false);
    http.send();
    return http.status != 404;
  }

}



// WEBPACK FOOTER //
// ./src/providers/movimientotesoreria-service/movimientotesoreria-service.ts